import { useEffect, useState } from "react";
import moment from "moment";
import { useForm } from "react-hook-form";
import {
    IGestaoBoleto,
    IGestaoBoletoFiltro,
} from "../../../Interfaces/Cobranca/Boleto/BoletoInterface";
import { useUserInfor } from "../../../Context/User";
import { ListarBoletosGestaoController } from "../../../Controllers/Cobranca/Boleto/BoletoController";
import {
    IEmpreendimento,
    IUnidade,
} from "../../../Interfaces/Geral/Produtos/ProdutosInterface";
import {
    ListarEmpreendimentosComObraController,
    ListarProdutosComUnidadesController,
} from "../../../Controllers/Geral/Produtos/ProdutosControllers";
import { UsuarioInterface } from "../../../Interfaces/Geral/GestaoUsuarios/UsuariosInterface";
import { ListarUsuariosController } from "../../../Controllers/Geral/GestaoUsuarios/UsuariosController";

export interface FilterFormDataInterface {
    ID_TIPO_FILTRO: number;
    DATA_INICIO: string;
    DATA_FIM: string;
    ID_GRUPO: Array<number>;
    FL_BOLETOS_NAO_QUITADOS: boolean;
    DS_NOME_CLIENTE: string;
    ID_EMPREENDIMENTO?: number;
    ID_UNIDADE?: number;
    ID_USUARIO_BUSCA?: number;
    ID_USUARIO_SOLICITANTE?: number;
    FL_BOLETOS_QUITADOS: boolean;
    ID_CASO: number;
}

interface IIndicadoresAcordos {
    VL_ACORDOS_QUITADOS: number | null;
    VL_ACORDOS_N_QUITADOS: number | null;
    VL_ACORDOS_ABERTOS: number | null;
    QTD_ACORDOS_QUITADOS: number | null;
    QTD_ACORDOS_N_QUITADOS: number | null;
    QTD_ACORDOS_ABERTOS: number | null;
    QTD_GERADO: number | null;
    QTD_N_ENVIADOS: number | null;
    VL_GERADOS: number | null;
    VL_N_ENVIADOS: number | null;
}

export function useGestaoAcordosCobranca() {
    const { UserInfor } = useUserInfor();
    moment.locale("pt-br");
    const FILTRO_GESTAO_ACORDOS_COBRANCA = sessionStorage.getItem(
        "FILTRO_GESTAO_ACORDOS_COBRANCA"
    );

    const todaysDate = new Date();
    //instancia um objeto date de 3 meses antes da data de hoje
    const pastDate = new Date(new Date().setMonth(todaysDate.getMonth() - 3));
    const filtroInicial = {
        ID_TIPO_FILTRO: 1,
        DATA_INICIO: pastDate.toISOString().substring(0, 10),
        DATA_FIM: todaysDate.toISOString().substring(0, 10),
        ID_GRUPO: [],
        FL_BOLETOS_NAO_QUITADOS: false,
        FL_BOLETOS_QUITADOS: false,
        ID_CASO: 0,
        DS_NOME_CLIENTE: "",
    };

    const [loading, setLoading] = useState(true);
    const [LstBoletos, setLstBoletos] = useState<Array<IGestaoBoleto>>();
    const [indicadores, setIndicadores] = useState<IIndicadoresAcordos>({
        VL_ACORDOS_QUITADOS: 0,
        VL_ACORDOS_N_QUITADOS: 0,
        VL_ACORDOS_ABERTOS: 0,
        QTD_ACORDOS_QUITADOS: 0,
        QTD_ACORDOS_N_QUITADOS: 0,
        QTD_ACORDOS_ABERTOS: 0,
        QTD_GERADO: 0,
        QTD_N_ENVIADOS: 0,
        VL_GERADOS: 0,
        VL_N_ENVIADOS: 0,
    });
    const totalNegociado = {
        QTD_TOTAL_NEGOCIADO:
            (indicadores.QTD_ACORDOS_N_QUITADOS ?? 0) +
            (indicadores.QTD_ACORDOS_QUITADOS ?? 0) +
            (indicadores.QTD_N_ENVIADOS ?? 0),
        VL_TOTAL_NEGOCIADO:
            (indicadores.VL_ACORDOS_N_QUITADOS ?? 0) +
            (indicadores.VL_ACORDOS_QUITADOS ?? 0) +
            (indicadores.VL_N_ENVIADOS ?? 0),
    };
    /**filtro */
    const [lstEmpreendimentos, setLstEmpreendimentos] = useState<
        Array<IEmpreendimento>
    >([]);
    const [lstUnidades, setLstUnidades] = useState<Array<IUnidade>>([]);
    const [lstUsuarios, setLstUsuarios] = useState<Array<UsuarioInterface>>([]);
    const [filter, setFilter] = useState<FilterFormDataInterface>(
        FILTRO_GESTAO_ACORDOS_COBRANCA
            ? JSON.parse(FILTRO_GESTAO_ACORDOS_COBRANCA)
            : filtroInicial
    );
    const [totalPages, setTotalPages] = useState(1);
    const { register, control, handleSubmit, reset } = useForm();
    useEffect(() => {
        ListarEmpreendimentosComObraController().then((res) => {
            setLstEmpreendimentos(res);
        });
        ListarUsuariosController()
            .then((res) => res.filter((u) => u.FL_ATIVO))
            .then((res) => {
                setLstUsuarios(res);
            });
    }, []);

    useEffect(() => {
        updateList({
            ...filter,
            NR_PAGINA: 1,
        });
    }, [filter]);

    const updateList = (data: IGestaoBoletoFiltro) => {
        setLoading(true);
        ListarBoletosGestaoController(data)
            .then((res) => {
                setTotalPages(res.NR_PAGINAS);
                setLstBoletos(res.lstAcordos);
                setIndicadores({
                    ...res,
                });
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleDateChange = (formData: FilterFormDataInterface) => {
        const filter = {
            ...formData,
            ID_CASO: formData.ID_CASO ? formData.ID_CASO : 0,
        };
        setFilter(filter);
        sessionStorage.setItem(
            "FILTRO_GESTAO_ACORDOS_COBRANCA",
            JSON.stringify(filter)
        );
    };

    const handleEmpreendimento = async (event: any) => {
        const ID_EMPREENDIMENTO = Number.parseInt(event.target.value);
        const empreendimento = lstEmpreendimentos.find(
            (empreendimento) =>
                empreendimento.ID_EMPREENDIMENTO === ID_EMPREENDIMENTO
        );
        if (empreendimento) {
            if (!empreendimento?.LISTA_PRODUTOS) {
                empreendimento.LISTA_PRODUTOS =
                    await ListarProdutosComUnidadesController(
                        empreendimento.ID_EMPREENDIMENTO
                    );
            }

            setLstUnidades(
                empreendimento.LISTA_PRODUTOS.reduce(
                    (unidades, produto) =>
                        unidades.concat(produto.UNIDADES || []),
                    [] as Array<IUnidade>
                )
            );
        } else {
            setLstUnidades([]);
        }
    };

    return {
        handleDateChange,
        loading,
        setLoading,
        UserInfor,
        register,
        control,
        handleSubmit,
        reset,
        lstUnidades,
        setLstUnidades,
        lstUsuarios,
        setLstUsuarios,
        totalPages,
        filter,
        setFilter,
        lstEmpreendimentos,
        setLstEmpreendimentos,
        totalNegociado,
        indicadores,
        setIndicadores,
        LstBoletos,
        setLstBoletos,
        filtroInicial,
        updateList,
        FILTRO_GESTAO_ACORDOS_COBRANCA,
        handleEmpreendimento,
    };
}
